import errorBoundary from '@ifeng/errorBoundary';
import PropTypes from 'prop-types';
import React from 'react';
import { callApp, getSchemeLink } from '@ifeng/callapp';
import { WxLaunchApp, QQShare } from 'ThreeTerminal_mobile';
import styles from './index.css';

class Mobile extends React.PureComponent {
    static propTypes = {
        schemeUrl: PropTypes.string,
        webUrl: PropTypes.string,
    };

    componentDidMount() {
        const { schemeUrl } = this.props;

        // location.href = schemeUrl;
    }

    callAppHandle = (isSendCount = true, isJumpQQlink = false, isCallAppWx = true) => {
        const { webUrl } = this.props;

        if (isCallAppWx) {
            callApp({
                docType: 'web',
                pid: webUrl,
                kind: 'brand_mxdb01',
                noKindFrom: 1,
                download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1464004002483',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8805',
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    };

    render() {
        // const { schemeUrl } = this.props;
        const { webUrl } = this.props;
        const clientSchemeLink = getSchemeLink({
            docType: 'web',
            pid: webUrl,
            kind: 'brand_mxdb01',
            noKindFrom: 1,
        });

        const qqShareCofig = {
            title: '凤凰新闻',
            img: 'https://x0.ifengimg.com/ucms/2021_30/09CDAF774A0F2BB348A3102BF59BE76CB84011D1_size324_w750_h378.png',
            desc: '',
            cb: () => {
                console.log('分享成功');
            },
        };

        return (
            <div className={styles.mobileBox}>
                <div onClick={this.callAppHandle} className={styles.mobileBoxA}>
                    <img
                        className={styles.mobileBoxImg}
                        src={require('./img/bg.png')}
                    />
                    <div className={styles.mobileBoxCopyright}>
                        <img
                            className={styles.mobileBoxCopyrightPic}
                            src="https://x0.ifengimg.com/ucms/2021_49/BFD562EF42E6C6D61443F4086BC83A95CB342799_size17_w530_h38.png"
                        />
                    </div>
                    <WxLaunchApp
                        launchType="app"
                        launchAppClick={this.callAppHandle.bind(this, true, false, false)}
                        schemeLink={clientSchemeLink}
                        launchAppFail={this.callAppHandle.bind(this, false, true, true)}
                    />
                </div>
                <QQShare content={qqShareCofig} />
            </div>
        );
    }
}

export default errorBoundary(Mobile);
